/**
 * Created by aleco on 9/26/2017.
 */

import { Component, Input, OnInit, AfterViewInit, Output, OnDestroy } from '@angular/core';
import { ServiceService } from "../../services/service.service";
import { saveAs } from 'file-saver';
import { PagerDataObject } from "../../entities/pagerDataObject";

import { Service } from '../../entities/service';
import { CsvMappingFields } from '../../entities/csvMappingFields';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subject, of } from 'rxjs';
import { catchError, delay, switchMap } from 'rxjs/operators';
import { CsvListService } from 'src/app/services/csvList.service';
import { SharedService } from 'src/app/services/sharedService';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'ntr-csv-list',
    templateUrl: './csvlist.component.html',
    styleUrls: ['./csvlist.component.css'],
    standalone: false
})
export class CsvListComponent implements OnInit, AfterViewInit, OnDestroy {

  service: Service = new Service();
  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  @Input()
  headers = [' ', 'Name', 'Code', 'Type'];
  @Input()
  disableHeader = false;
  subscription: any;
  currentFileFormatId: any;
  startLoading: boolean = false;
  yearLoading: boolean = false;
  downloading: boolean = false;
  query: string;
  splitByYear = false;
  years: number[] = [];
  hasNoYear = false;
  activeYear: number | string | null = null; // a year number, or '__none__', or null
  private yearsSub: any;
  private dataSub$ = new Subject<any>();

  /** Admin-authored description of the selected file format. Plain text; '' when unset. */
  portalDescription = '';

  constructor(private serviceService: ServiceService, private sharedService: SharedService,
              private csvListService: CsvListService, private route: ActivatedRoute,
              private router: Router, private spinner: NgxSpinnerService) {
    this.metaInfo = [];
    this.columns = [];
  }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('id')) {
      this.route.paramMap.pipe(
        switchMap((params: ParamMap) => {
          this.data = null;
          this.columns = [];
          this.metaInfo = [];
          return this.serviceService.getService(params.get('id'));
        }))
        .subscribe(service => {
          this.getServiceData(service);
        });
    } else {
      this.serviceService.getTotalServiceList("").subscribe(services => {
        if (services.length > 0)
          this.router.navigate(['/csv-list', services[0].id], { replaceUrl: true });
      })
    }
  }

  ngAfterViewInit(): void {
    this.sharedService.loadMenuItems('services');
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.yearsSub) {
      this.yearsSub.unsubscribe();
    }
  }

  onGridQuery(query) {
    this.query = query;
    this.dataSub$.next(query);
  }

  downloadExcel() {
    this.downloading = true;
    const raw = this.query || this.buildInitialQuery();
    const query = raw.replace(/[&?]?from=\d+/, '').replace(/[&?]?size=\d+/, '') + this.yearQueryPart();
    this.serviceService.downloadExcel(this.service.id, this.currentFileFormatId, query).subscribe(
      data => {
        this.downloading = false;
        const file = new Blob([data], {});
        const filename = 'document-' + Date.now() + '.xlsx';
        saveAs(file, filename);
      },
      _err => {
        this.downloading = false;
      }
    );
  }

  private buildColumns(mappingObjects: any[]): any[] {
    return (mappingObjects || [])
      .filter(mo => mo?.type && mo.type !== 1)
      .map(mo => ({
        name: mo.name,
        tag: mo.alias?.trim()?.length ? mo.alias.trim() : mo.name,
        key: mo.name,
        description: mo.description,
        filtering: true,
        sorting: true,
        sortingOrder: 'asc',
        type: mo.type,
        isNumber: CsvMappingFields.isAmountColumn(mo)
      }));
  }

  onChange(selectedFileFormat) {
    this.startLoading = true;
    this.query = '';
    this.currentFileFormatId = selectedFileFormat;
    // eslint-disable-next-line eqeqeq
    const fmt = this.service.fileFormats?.find(item => item['id'] == this.currentFileFormatId)
                ?? this.service.fileFormats?.[0];
    if (fmt) this.currentFileFormatId = fmt['id'];
    this.portalDescription = this.descriptionFor(this.currentFileFormatId);
    this.columns = fmt ? this.buildColumns(fmt['mappingObjects']) : [];
    this.metaInfo = this.columns.map(c => c.name);
    this.query = this.buildInitialQuery();
    this.setupYears(fmt);
    if (!this.splitByYear) {
      this.dataSub$.next(this.query);
    }
  }


  getServiceData(service) {
    this.service = service;
    this.data = null;
    this.columns = [];
    this.metaInfo = [];
    this.query = '';
    this.portalDescription = '';
    this.splitByYear = false;

    let resolvedFmt: any = null;

    if (this.service.fileFormats?.length > 0) {
      const defaultId = this.service.defaultFileFormat ?? this.service.fileFormats[0]['id'];
      // eslint-disable-next-line eqeqeq
      resolvedFmt = this.service.fileFormats.find(item => item['id'] == defaultId) ?? this.service.fileFormats[0];
      this.currentFileFormatId = resolvedFmt['id'];
      this.portalDescription = this.descriptionFor(this.currentFileFormatId);
      this.columns = this.buildColumns(resolvedFmt['mappingObjects']);
      this.metaInfo = this.columns.map(c => c.name);
      this.query = this.buildInitialQuery();
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.dataSub$.pipe(
      switchMap(filter => {
        return this.csvListService.getData(
          filter + '&serviceId=' + this.service.id +
          ((this.currentFileFormatId === undefined) ? '' : '&fileFormatId=' + this.currentFileFormatId) +
          this.yearQueryPart()
        ).pipe(
          delay(500),
          catchError(err => {
            console.error('csvlist getData error:', err);
            this.startLoading = false;
            this.yearLoading = false;
            return of(null);
          })
        );
      })
    ).subscribe(data => {
      this.startLoading = false;
      this.yearLoading = false;
      if (data === null) return;
      this.data = data;
      this.metaInfo = this.columns.map(c => c.name);
    });

    this.setupYears(resolvedFmt);

    if (!this.splitByYear) {
      this.dataSub$.next(this.buildInitialQuery());
    }
  }

  private buildInitialQuery(): string {
    let q = '?q=&';
    for (const col of this.columns) {
      if (col.filtering) {
        q += encodeURIComponent(col.key) + '=&';
      }
    }
    const sortCol = this.columns.find(c => c.sorting && c.sortingOrder);
    if (sortCol) {
      q += 'sort=' + encodeURIComponent(sortCol.key) + ':' + (sortCol.sortingOrder === 'desc' ? -1 : 1) + '&';
    }
    q += 'from=0&size=10';
    return q;
  }

  private yearQueryPart(): string {
    if (!this.splitByYear || this.activeYear === null || this.activeYear === undefined) return '';
    return '&extracted_year=' + encodeURIComponent(this.activeYear);
  }

  private setupYears(fmt: any): void {
    this.splitByYear = !!fmt?.['splitByYear'];
    this.years = [];
    this.hasNoYear = false;
    this.activeYear = null;
    if (!this.splitByYear) { return; }
    this.startLoading = true;
    if (this.yearsSub) { this.yearsSub.unsubscribe(); }
    this.yearsSub = this.csvListService.getYears(this.service.id, this.currentFileFormatId).subscribe(
      res => {
        this.years = res?.years || [];
        this.hasNoYear = !!res?.hasNoYear;
        this.activeYear = this.years.length ? this.years[0] : (this.hasNoYear ? '__none__' : null);
        this.dataSub$.next(this.query || this.buildInitialQuery());
      },
      err => {
        console.error('csvlist getYears error:', err);
        this.splitByYear = false;
        this.dataSub$.next(this.query || this.buildInitialQuery());
      }
    );
  }

  selectYear(year: any) {
    this.activeYear = year;
    this.yearLoading = true;
    this.dataSub$.next(this.query || this.buildInitialQuery());
  }

  /**
   * Loose id comparison: file format ids come back as string or number
   * depending on the caller, the same reason onChange/getServiceData use `==`.
   */
  descriptionFor(fileFormatId: any): string {
    // eslint-disable-next-line eqeqeq
    const fmt = (this.service?.fileFormats || []).find(f => f['id'] == fileFormatId);
    return fmt?.['portalDescription'] || '';
  }

}
